import { useServerRequest } from '../../api'
import { type GetHookResponse } from '../../hooks'
import { gamePrizeDownloadKey } from '../../keys'
import { useTantalimQuery } from '../../query'
import { type GamePrizeDownloadInput, type GamePrizeDownloadSuccess, HOUR, isNotEmpty } from '@terros/common'
import { useCallback } from 'react'

export function usePrizeDownload(url: string): GetHookResponse<{ image: string }> {
  return useTantalimQuery<GamePrizeDownloadInput, GamePrizeDownloadSuccess, { image: string }>({
    url: '/game/prize/download',
    queryKey: gamePrizeDownloadKey(url),
    input: { url },
    convertResponse: (data) => data,
    options: {
      enabled: isNotEmpty(url),
      gcTime: HOUR,
      staleTime: HOUR,
    },
  })
}

export const useGetPrizeDownload = (): ((url: string) => Promise<GamePrizeDownloadSuccess>) => {
  const serverRequest = useServerRequest<GamePrizeDownloadInput, GamePrizeDownloadSuccess>('/game/prize/download')
  return useCallback(
    async (url: string): Promise<GamePrizeDownloadSuccess> => {
      return serverRequest({ url })
    },
    [serverRequest]
  )
}
